import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Input,
  ListItem,
} from '@material-ui/core'

// actions
import {
  updateTerminal,
  addNewTerminal,
  deleteTerminal,
  getCompanyFeatures,
  getRegions,
  getRegionsByTerminal,
} from '../../../actions/company'
import { fetchInventories, loadBrands } from '../../../actions/inventory'
import {
  getShopList,
  getShopTerminals,
  getNotificationsList,
  updateNotification,
} from '../../../actions/shop'
import { openErrorMessage } from '../../../actions/message'
import { getThirdPartyAccounts } from '../../../actions/thirdParty'
import { isFeatureFlagEnable } from '../../../api/unleash'

// utils
import { sortArrayByName } from '../../../utils/array'
import { hasAccess } from '../../../utils/api'
import { UnleashToggles } from '../../../types/unleashToggles'
import { isValidCurrencyInput, checkEmail } from '../../../utils/validations/common'

// local components
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ShopSettingsWithUpdate from '../../../components/layout/ShopSettingsWithUpdate'
import ShopTerminalItemContainer from '../../../components/Terminals/ShopTerminalItemContainer'
import ModalDialog from '../../../components/common/ModalDialog'
import { EditableReactSelectCreatable } from '../../../components/common/EditableComponents'
import {
  Appcues,
  cashDrawerSettingNames,
  cashDrawerLimitExceedsNotificationType,
} from '../../../utils/constants'
import { trackUserPilotEvent } from '../../../userpilotClient'

import { getPosTerminals } from '../../../actions/dejavoo'

const NewBadge = () => (
  <span
    style={{
      display: 'inline-block',
      backgroundColor: '#1cc4e8',
      color: '#fff',
      fontSize: 10,
      fontWeight: 700,
      padding: '2px 6px',
      borderRadius: 3,
      marginLeft: 8,
      letterSpacing: 0.5,
      verticalAlign: 'middle',
      lineHeight: '16px',
    }}
  >
    NEW
  </span>
)

const emptyTerminal = {
  id: '',
  name: '',
  enabled: false,
  shopId: '',
  assignedInventoryId: '',
  checkoutType: '',
  deviceName: '',
  posTerminal: '',
  active: true,
}

class ShopTerminals extends PureComponent {
  state = {
    showEmptyTerminal: false,
    selectedToDeleteTerminal: {},
    posTerminals: [],
    validationList: [],
    eventLedgerEnabled: false,
    autoCashDrawer: !!(this.props.shop && this.props.shop.autoCashDrawer),
    enforceCashDrawers: !!(this.props.shop && this.props.shop.enforceCashDrawers),
    enforceBlindCashDrawer: !!(this.props.shop && this.props.shop.enforceBlindCashDrawer),
    drawerQuickStartEnabled: !!(this.props.shop && this.props.shop.cashDrawerQuickStartEnabled),
    quickStartSectionAmount: 0,
    cashDrawerLimitNotification: null,
    maxCashDrawerLimitDraft: '',
    sendEmailToDraft: [],
  }

  getSharedQuickStartAmount = (terminalsList = []) => {
    if (terminalsList.length === 0) {
      return '-'
    }

    const amounts = terminalsList.map((terminal) => terminal.quickStartAmount || 0)
    const allTerminalsMatch = amounts.every((amount) => amount === amounts[0])

    return allTerminalsMatch ? amounts[0] : '-'
  }

  initialLoad = () => {
    const { shop } = this.props
    const { id } = shop
    this.props.dispatch(getRegionsByTerminal())
    return this.props.dispatch(getShopTerminals(id)).then((res) => {
      const terminalsList = (res && res.values) || []
      this.setState({
        validationList: terminalsList,
        quickStartSectionAmount: this.getSharedQuickStartAmount(terminalsList),
      })
    })
  }

  loadCashDrawerLimitNotification = () => {
    return this.props.dispatch(getNotificationsList()).then((notifications = []) => {
      const cashDrawerLimitNotification = notifications.find(
        (notification) => notification.notificationType === cashDrawerLimitExceedsNotificationType,
      )
      if (cashDrawerLimitNotification) {
        this.setState({
          cashDrawerLimitNotification,
          maxCashDrawerLimitDraft: cashDrawerLimitNotification.maxCashDrawerLimit || '',
          sendEmailToDraft: cashDrawerLimitNotification.defaultEmail
            ? cashDrawerLimitNotification.defaultEmail.split(',')
            : [],
        })
      }
    })
  }

  componentDidMount() {
    const { shop } = this.props
    const { id } = shop

    this.initialLoad()
    this.loadCashDrawerLimitNotification()
    this.props.dispatch(fetchInventories(id))
    this.props.dispatch(getThirdPartyAccounts())
    this.props.dispatch(getShopList())
    this.props.dispatch(getCompanyFeatures())
    this.props.dispatch(loadBrands({ start: 0, limit: 0 }))
    isFeatureFlagEnable(UnleashToggles.EVENT_LEDGER)
      .catch(() => false)
      .then((eventLedgerEnabled) => this.setState({ eventLedgerEnabled }))

    const session = this.props.authReducer.session
    if (
      session &&
      session.assignedShop &&
      session.assignedShop.paymentOptions &&
      session.assignedShop.paymentOptions.length > 0
    ) {
      var blazePayPermission = session.assignedShop.paymentOptions.find(
        (po) => po.paymentOption === 'BlazePay',
      )
      if (blazePayPermission && blazePayPermission.enabled) {
        this.props.dispatch(getPosTerminals()).then((response) => {
          this.setState({
            posTerminals: response,
          })
        })
      }
    }
  }

  onTerminalUpdate = (data, afterOnSave) => {
    if (this.validateTerminal(data)) {
      this.props.dispatch(updateTerminal(data)).then((response) => {
        Appcues.track('Updated Shop Terminal')
        this.props.dispatch(this.initialLoad)
        afterOnSave(response)
      })
    }
  }

  openDeleteModal = (terminal) => (e) => {
    this.setState({
      selectedToDeleteTerminal: terminal,
    })

    this.deleteModal.handleClickOpen()
  }

  onDeleteTerminal = (terminal) => (e) => {
    this.deleteModal.handleClose()

    this.props.dispatch(deleteTerminal(terminal.id)).then((response) => {
      Appcues.track('Shop Terminal Deleted')
      this.props.dispatch(this.initialLoad)
    })
  }

  toogleEmptyTerminal = () => {
    Appcues.track('Adding Shop Terminal')
    this.setState((prevState) => ({
      showEmptyTerminal: !prevState.showEmptyTerminal,
    }))
  }

  addNewTerminal = (data, afterOnSave) => {
    if (this.validateTerminal(data) && this.validateCheckoutType(data)) {
      this.props.dispatch(addNewTerminal(data)).then((terminal) => {
        Appcues.track('Added New Shop Terminal')
        this.props.dispatch(this.initialLoad)
        this.toogleEmptyTerminal()
      })
    }
  }

  validateTerminal = (terminal) => {
    if (!terminal.name) {
      this.props.dispatch(openErrorMessage('Please enter terminal name'))
      return false
    }
    return true
  }

  validateCheckoutType = (terminal) => {
    if (!terminal && !terminal.checkoutType) {
      this.props.dispatch(openErrorMessage('Please select Checkout Type'))
      return false
    }
    return true
  }

  refreshValidationList = (terminalId, key, value) => {
    const currentTerminals = this.state.validationList.map((terminal) => {
      if (terminal.id == terminalId) {
        terminal[key] = value
      }
      return terminal
    })

    this.setState({ validationList: currentTerminals || [] })
  }

  getCashDrawerToggleFields = () => ({
    autoCashDrawer: this.state.autoCashDrawer,
    enforceCashDrawers: this.state.enforceCashDrawers,
    enforceBlindCashDrawer: this.state.enforceBlindCashDrawer,
    cashDrawerQuickStartEnabled: this.state.drawerQuickStartEnabled,
  })

  onToggleDrawerQuickStart = () => {
    const newValue = !this.state.drawerQuickStartEnabled
    this.setState({ drawerQuickStartEnabled: newValue })
    this.props
      .updateShop({
        ...this.props.shop,
        ...this.getCashDrawerToggleFields(),
        cashDrawerQuickStartEnabled: newValue,
      })
      .catch(() => this.setState({ drawerQuickStartEnabled: !newValue }))
  }

  onToggleCashDrawerSetting = (key) => () => {
    const newValue = !this.state[key]
    this.setState({ [key]: newValue })
    this.props
      .updateShop({
        ...this.props.shop,
        ...this.getCashDrawerToggleFields(),
        [key]: newValue,
      })
      .then(() => {
        trackUserPilotEvent('cash_drawer_setting_updated', {
          shop_id: this.props.shop.id,
          setting_name: cashDrawerSettingNames[key],
          source_page: 'terminals',
          value: newValue,
        })
      })
      .catch(() => this.setState({ [key]: !newValue }))
  }

  onQuickStartSectionAmountChange = (value) => {
    if (isValidCurrencyInput(value)) {
      this.setState({ quickStartSectionAmount: value })
    }
  }

  onQuickStartSectionAmountFocus = () => {
    if (this.state.quickStartSectionAmount === '-') {
      this.setState({ quickStartSectionAmount: '' })
    }
  }

  trackCashDrawerLimitNotificationChange = (settingName, value) => {
    trackUserPilotEvent('cash_drawer_setting_updated', {
      shop_id: this.props.shop.id,
      setting_name: settingName,
      source_page: 'terminals',
      value,
    })
  }

  onToggleCashDrawerLimitNotification = () => {
    const { cashDrawerLimitNotification } = this.state
    if (!cashDrawerLimitNotification) {
      return
    }

    const updatedNotification = {
      ...cashDrawerLimitNotification,
      active: !cashDrawerLimitNotification.active,
    }
    this.setState({ cashDrawerLimitNotification: updatedNotification })
    this.props
      .dispatch(updateNotification(updatedNotification))
      .then(() =>
        this.trackCashDrawerLimitNotificationChange(
          cashDrawerSettingNames.cashDrawerLimitExceeds,
          updatedNotification.active,
        ),
      )
      .catch(() => this.setState({ cashDrawerLimitNotification }))
  }

  onMaxCashDrawerLimitChange = (value) => {
    if (isValidCurrencyInput(value)) {
      this.setState({ maxCashDrawerLimitDraft: value })
    }
  }

  onApplyMaxCashDrawerLimit = () => {
    const { cashDrawerLimitNotification, maxCashDrawerLimitDraft } = this.state
    const amount = parseFloat(maxCashDrawerLimitDraft)

    if (isNaN(amount) || amount < 1) {
      this.props.dispatch(openErrorMessage('Please enter a valid max cash drawer limit'))
      return
    }

    if (amount === cashDrawerLimitNotification.maxCashDrawerLimit) {
      return
    }

    const updatedNotification = { ...cashDrawerLimitNotification, maxCashDrawerLimit: amount }
    this.setState({
      cashDrawerLimitNotification: updatedNotification,
      maxCashDrawerLimitDraft: amount,
    })
    this.props
      .dispatch(updateNotification(updatedNotification))
      .then(() =>
        this.trackCashDrawerLimitNotificationChange(
          cashDrawerSettingNames.cashDrawerLimitMaxAmount,
          amount,
        ),
      )
      .catch(() =>
        this.setState({
          cashDrawerLimitNotification,
          maxCashDrawerLimitDraft: cashDrawerLimitNotification.maxCashDrawerLimit || '',
        }),
      )
  }

  onSendEmailToChange = (options = []) => {
    this.setState({ sendEmailToDraft: options.map((option) => option.value) })
  }

  onApplySendEmailTo = () => {
    const { cashDrawerLimitNotification, sendEmailToDraft } = this.state
    const emails = sendEmailToDraft.map((email) => email.trim()).filter(Boolean)
    const newValue = emails.length ? emails.join(',') : null

    if (newValue === (cashDrawerLimitNotification.defaultEmail || null)) {
      return
    }

    if (emails.some((email) => !checkEmail(email))) {
      this.props.dispatch(openErrorMessage('Please provide valid email.'))
      return
    }

    const updatedNotification = { ...cashDrawerLimitNotification, defaultEmail: newValue }
    this.setState({ cashDrawerLimitNotification: updatedNotification, sendEmailToDraft: emails })
    this.props
      .dispatch(updateNotification(updatedNotification))
      .then(() =>
        this.trackCashDrawerLimitNotificationChange(
          cashDrawerSettingNames.cashDrawerLimitEmail,
          newValue,
        ),
      )
      .catch(() => this.setState({ cashDrawerLimitNotification, sendEmailToDraft }))
  }

  onApplyToAll = async () => {
    this.applyToAllModal.handleClose()

    const amount = parseFloat(this.state.quickStartSectionAmount)

    if (isNaN(amount) || amount < 1) {
      this.props.dispatch(openErrorMessage('Please enter a valid quick start amount'))
      return
    }

    const { terminals = {} } = this.props.companyReducer
    const terminalsValues = terminals.values || []

    await Promise.allSettled(
      terminalsValues.map((terminal) =>
        this.props.dispatch(updateTerminal({ ...terminal, quickStartAmount: amount })),
      ),
    )

    await this.initialLoad()
  }

  getBlazePayPermissions = (assignedShop) => {
    if (assignedShop && assignedShop.paymentOptions && assignedShop.paymentOptions.length > 0) {
      return assignedShop.paymentOptions.find((po) => po.paymentOption === 'BlazePay')
    }
    return null
  }

  render() {
    const { session = {} } = this.props.authReducer
    emptyTerminal.checkoutType = session.assignedShop && session.assignedShop.checkoutType
    const { assignedShop = {} } = session || {}
    var blazePayPermission = this.getBlazePayPermissions(assignedShop)
    const { inventories = {} } = this.props.inventoryReducer

    const { terminals = {}, lastModified = null, companyFeatures } = this.props.companyReducer

    const { thirdPartyAccounts = {} } = this.props.thirdPartyReducer

    const {
      showEmptyTerminal,
      selectedToDeleteTerminal,
      posTerminals,
      validationList = [],
      eventLedgerEnabled,
      autoCashDrawer,
      enforceCashDrawers,
      enforceBlindCashDrawer,
      drawerQuickStartEnabled,
      quickStartSectionAmount,
      cashDrawerLimitNotification,
      maxCashDrawerLimitDraft,
      sendEmailToDraft,
    } = this.state

    const terminalsValues = sortArrayByName(terminals.values || [])
    const inventoryValues = inventories.values || []
    const thirdPartyAccountsValues = thirdPartyAccounts.values || []

    const activeInventories = inventoryValues.filter((inventory) => inventory.active)

    const permitted = hasAccess()

    const { availableApps = [] } = companyFeatures

    const blazeEventsEnabled =
      this.props.companyReducer &&
      this.props.companyReducer.companyFeatures &&
      this.props.companyReducer.companyFeatures.blazeEvent

    return (
      <div>
        <Grid container>
          {permitted ? (
            <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
              <Button
                variant="raised"
                className="primary-button pull-right margin-bottom-small"
                onClick={this.toogleEmptyTerminal}
              >
                Add Terminal
              </Button>
            </Grid>
          ) : (
            <Grid className="addButton" item xs={12} sm={12} md={12} lg={12} />
          )}
        </Grid>
        <Grid container style={{ marginBottom: 16 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <ListItem>
                <Grid container>
                  <Grid item xs={12}>
                    <span style={{ fontWeight: 600, fontSize: 15 }}>Cash drawer settings</span>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Enable Auto Cash Drawers
                  </Grid>
                  <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                    <Switch
                      checked={autoCashDrawer}
                      onChange={this.onToggleCashDrawerSetting('autoCashDrawer')}
                      color="primary"
                    />
                  </Grid>
                  <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                    <span>
                      When enabled, cash drawer sessions are automatically created for the new day.
                      The previous day cash drawer session's expected amount will carry over to the
                      new day's session.
                    </span>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Enforce Cash Drawers for Sales
                  </Grid>
                  <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                    <Switch
                      checked={enforceCashDrawers}
                      onChange={this.onToggleCashDrawerSetting('enforceCashDrawers')}
                      color="primary"
                    />
                  </Grid>
                  <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                    <span>
                      When enabled, cash drawers need to exists for the terminal that the sales are
                      made.
                    </span>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Enforce Blind Cash Drawer Counts
                  </Grid>
                  <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                    <Switch
                      checked={enforceBlindCashDrawer}
                      onChange={this.onToggleCashDrawerSetting('enforceBlindCashDrawer')}
                      color="primary"
                    />
                  </Grid>
                  <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                    <span>When enabled, expected amount in cash drawer will be hidden.</span>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Cash Drawer Limit Exceeds Notification
                  </Grid>
                  <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                    <Switch
                      checked={
                        !!(cashDrawerLimitNotification && cashDrawerLimitNotification.active)
                      }
                      onChange={this.onToggleCashDrawerLimitNotification}
                      disabled={!cashDrawerLimitNotification}
                      color="primary"
                    />
                  </Grid>
                  <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                    <span>
                      When enabled, an email is sent and a notice is displayed on the POS once a
                      drawer goes over the maximum limit.
                    </span>
                  </Grid>
                </Grid>
              </ListItem>
              {cashDrawerLimitNotification && cashDrawerLimitNotification.active && (
                <>
                  <ListItem>
                    <Grid container>
                      <Grid
                        className="labelField"
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        style={{ paddingLeft: 24 }}
                      >
                        Max Cash Drawer Limit
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1} />
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span>$</span>
                          <Input
                            value={maxCashDrawerLimitDraft}
                            onChange={(e) => this.onMaxCashDrawerLimitChange(e.target.value)}
                            type="number"
                            inputProps={{ min: 1, step: 1 }}
                            className="no-spinner"
                            style={{ width: 80 }}
                          />
                          <Button
                            className="primary-button"
                            onClick={this.onApplyMaxCashDrawerLimit}
                            style={{ marginLeft: 24 }}
                          >
                            Apply
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid
                        className="labelField"
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        style={{ paddingLeft: 24 }}
                      >
                        Send email to
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1} />
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <EditableReactSelectCreatable
                              multi={true}
                              value={sendEmailToDraft.map((email) => ({
                                label: email,
                                value: email,
                              }))}
                              onChange={this.onSendEmailToChange}
                              valueToRender={sendEmailToDraft.join(', ')}
                              editMode={true}
                              options={sendEmailToDraft.map((email) => ({
                                label: email,
                                value: email,
                              }))}
                              clearable={false}
                            />
                          </div>
                          <Button
                            className="primary-button"
                            onClick={this.onApplySendEmailTo}
                            style={{ marginLeft: 24, flexShrink: 0, whiteSpace: 'nowrap' }}
                          >
                            Apply
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </ListItem>
                </>
              )}
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                      Enable Quick Start Amount
                      <NewBadge />
                    </span>
                  </Grid>
                  <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                    <Switch
                      checked={drawerQuickStartEnabled}
                      onChange={this.onToggleDrawerQuickStart}
                      color="primary"
                    />
                  </Grid>
                  <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                    <span>
                      When enabled, budtenders get a one-tap Quick Start button on the open-drawer
                      screen.
                    </span>
                  </Grid>
                </Grid>
              </ListItem>
              {drawerQuickStartEnabled && (
                <ListItem>
                  <Grid container>
                    <Grid
                      className="labelField"
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={6}
                      style={{ paddingLeft: 24 }}
                    >
                      Quick start amount
                    </Grid>
                    <Grid className="editField" item xs={12} sm={2} md={2} lg={1} />
                    <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span>$</span>
                        <Input
                          value={quickStartSectionAmount}
                          onChange={(e) => this.onQuickStartSectionAmountChange(e.target.value)}
                          onFocus={this.onQuickStartSectionAmountFocus}
                          type="text"
                          inputProps={{ style: { textAlign: 'right' } }}
                          className="no-spinner"
                          style={{ width: 80 }}
                        />
                        <Button
                          className="primary-button"
                          onClick={() => this.applyToAllModal.handleClickOpen()}
                          style={{ marginLeft: 24 }}
                        >
                          Apply to All
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
              )}
            </Paper>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div className="table cus-pager-top">
              <Paper>
                <Table className="cell-padd-remove">
                  <TableHead>
                    <TableRow>
                      <TableCell className="tab-id">ID</TableCell>
                      <TableCell>Terminal Name</TableCell>
                      <TableCell>Device Name</TableCell>
                      <TableCell>Terminal Type</TableCell>
                      {availableApps.length > 0 &&
                      availableApps &&
                      availableApps.indexOf('Dispatch') >= 0 ? (
                        <TableCell>Region</TableCell>
                      ) : null}
                      <TableCell>Assigned Inventory</TableCell>
                      {/* <TableCell>Assigned Cash Vault</TableCell> */}
                      <TableCell>Checkout Type</TableCell>
                      {blazePayPermission && blazePayPermission.enabled ? (
                        <TableCell>POS Terminal</TableCell>
                      ) : null}
                      {blazeEventsEnabled ? <TableCell>Brands</TableCell> : null}
                      {drawerQuickStartEnabled ? (
                        <TableCell>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            Quick Start
                            <NewBadge />
                          </div>
                        </TableCell>
                      ) : null}
                      <TableCell>Status</TableCell>
                      {permitted ? <TableCell></TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showEmptyTerminal ? (
                      <ShopTerminalItemContainer
                        terminal={emptyTerminal}
                        lastModified={lastModified}
                        onTerminalUpdate={this.addNewTerminal}
                        inventories={activeInventories}
                        onCancel={this.toogleEmptyTerminal}
                        thirdPartyAccounts={thirdPartyAccountsValues}
                        defaultEditMode={true}
                        blazePayPermission={blazePayPermission}
                        posTerminals={posTerminals}
                        refreshValidationList={this.refreshValidationList}
                        validationList={validationList}
                        eventLedgerEnabled={eventLedgerEnabled}
                        drawerQuickStartEnabled={drawerQuickStartEnabled}
                        quickStartAmount={0}
                      />
                    ) : null}
                    {terminalsValues.map((row, index) => {
                      return (
                        <ShopTerminalItemContainer
                          key={index}
                          terminal={row}
                          lastModified={lastModified}
                          onTerminalUpdate={this.onTerminalUpdate}
                          inventories={activeInventories}
                          thirdPartyAccounts={thirdPartyAccountsValues}
                          onDelete={this.openDeleteModal(row)}
                          permitted={permitted}
                          blazePayPermission={blazePayPermission}
                          posTerminals={posTerminals}
                          refreshValidationList={this.refreshValidationList}
                          validationList={validationList}
                          eventLedgerEnabled={eventLedgerEnabled}
                          drawerQuickStartEnabled={drawerQuickStartEnabled}
                          quickStartAmount={row.quickStartAmount || 0}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </Paper>
            </div>
          </Grid>
          <ModalDialog
            ref={(c) => (this.deleteModal = c)}
            onConfirm={this.onDeleteTerminal(selectedToDeleteTerminal)}
            confirmText="delete"
          >
            Are you sure you want to delete '{selectedToDeleteTerminal.name}'?
          </ModalDialog>
          <ModalDialog
            ref={(c) => (this.applyToAllModal = c)}
            title="Apply to All Terminals"
            onConfirm={this.onApplyToAll}
            confirmText="Apply"
          >
            This will override the Quick Start amount for all terminals. Are you sure?
          </ModalDialog>
        </Grid>
      </div>
    )
  }
}

export default connect(
  ({
    dispatch,
    shopReducer,
    companyReducer,
    inventoryReducer,
    thirdPartyReducer,
    authReducer,
  }) => ({
    dispatch,
    shopReducer,
    companyReducer,
    inventoryReducer,
    thirdPartyReducer,
    authReducer,
  }),
)(ShopSettingsWithUpdate(ContainerWithTitle(ShopTerminals, 'Shop Terminals')))



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/ShopTerminals.js